import styled from "@emotion/styled";
import { breakpoints } from "@trustpilot/businessapp-patternlibrary";

interface StyledMenuWrapperProps {
  hideOnMobile: boolean;
}

export const StyledMenuWrapper = styled.div<StyledMenuWrapperProps>(
  {
    [`@media (max-width: ${breakpoints.small}px)`]: {
      margin: "0 6px 0 0",
      "&:last-of-type": {
        margin: 0,
      },
    },
  },
  ({ hideOnMobile }) => ({
    display: hideOnMobile ? "none" : "block",
    [`@media (min-width: ${breakpoints.medium}px)`]: {
      display: "block",
      position: "relative",
    },
  }),
);

export const StyledMenuIconWrapper = styled.div({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const StyledMenuIcon = styled.i({
  display: "flex",
  alignItems: "center",
  fontStyle: "normal",
});

export const StyledMenuContent = styled.div({
  position: "absolute",
  boxShadow: `var(--box-shadow-30)`,
  background: "var(--neutral-white)",
  border: `1px solid var( --divider-subtle)`,
  top: "100%",
  right: 0,
  borderRadius: "8px",
  minWidth: "260px",

  [`@media (min-width: ${breakpoints.medium}px)`]: {
    left: "auto",
    width: "auto",
    right: -8,
    top: "calc(100% + 12px)",
  },
});
